angular.module('pipSearchBar', ['ngMaterial', 'pipNav.Translate', 'pipNav.Templates']);

import './SearchConfig';
import './ISearchService';
import './SearchService';
import './SearchBar';

export * from './ISearchService';
